import { useMemo, useState } from 'react';
import { Form } from 'react-bootstrap';
import iconData from '../../../assets/bi-icons.json';

const ICON_OPTIONS = Array.isArray(iconData?.icons)
  ? [...iconData.icons].sort((a, b) => a.localeCompare(b))
  : [];

function getIconToken(value) {
  if (typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('bi-')) return trimmed;
  if (trimmed.startsWith('bi ')) {
    const maybeToken = trimmed.slice(3).trim();
    return maybeToken.startsWith('bi-') ? maybeToken : '';
  }

  const match = trimmed.match(/bi-[a-z0-9-]+/i);
  return match ? match[0].toLowerCase() : '';
}

export default function IconClassPicker({
  value,
  onChange,
  label = 'Icon class (optional)',
  placeholder = 'Search icons...',
  maxRows = 6
}) {
  const [search, setSearch] = useState('');
  const selectedIcon = getIconToken(value);

  const filteredIcons = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return ICON_OPTIONS;

    return ICON_OPTIONS.filter((icon) => icon.includes(query) || `bi ${icon}`.includes(query));
  }, [search]);

  return (
    <Form.Group className="mb-2">
      <Form.Label>{label}</Form.Label>
      <Form.Control
        type="search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder={placeholder}
        className="mb-2"
      />

      <div className="pagebuilder-icon-picker-meta">
        {filteredIcons.length} icon class{filteredIcons.length === 1 ? '' : 'es'}
      </div>

      <div
        className="pagebuilder-icon-picker-grid"
        style={{ '--pagebuilder-icon-picker-max-rows': String(Math.max(1, Number(maxRows) || 1)) }}
        role="listbox"
        aria-label="Bootstrap icon class picker"
      >
        <button
          type="button"
          className={`pagebuilder-icon-picker-tile ${!selectedIcon ? 'is-selected' : ''}`}
          onClick={() => onChange('')}
          title="No icon"
        >
          <i className="bi bi-slash-circle" aria-hidden="true" />
          <span>None</span>
        </button>

        {filteredIcons.map((icon) => {
          const iconClass = `bi ${icon}`;
          const selected = selectedIcon === icon;

          return (
            <button
              key={icon}
              type="button"
              className={`pagebuilder-icon-picker-tile ${selected ? 'is-selected' : ''}`}
              onClick={() => onChange(iconClass)}
              title={iconClass}
            >
              <i className={iconClass} aria-hidden="true" />
              <span>{iconClass}</span>
            </button>
          );
        })}
      </div>

      {!filteredIcons.length && <p className="pagebuilder-sublist-empty mb-0 mt-2">No icon classes match your search.</p>}
    </Form.Group>
  );
}
